import { UserType } from '@upstart/harmony/lib/constants';
import React, { FunctionComponent, useEffect } from 'react';
import { toast } from 'react-toastify';
import { DealerLaunchDashboard } from './components/DealerLaunchDashboard/DealerLaunchDashboard';
import { Login } from './components/Login/Login';
import { Spinner } from './components/Spinner/Spinner';
import { SupportDashboard } from './components/SupportDashboard/SupportDashboard';
import { fetchCurrentUser } from './redux/auth/thunks';
import { fetchGlobalConfigurations } from './redux/globalConfigurations/thunks';
import { store, useAppDispatch, useTypedSelector } from './redux/store';
import { logout } from './utils/redux';
import { OTPForm } from './components/OTPForm/OTPForm';
import { registerSessionTimeoutCallback } from './utils/session-timeout';
import SystemDown from './components/SystemDown/SystemDown';
import {
  getSearchParameters,
  getSystemStatus,
} from './utils/systemMaintenanceUtils';
import { byPassMaintenanceMode } from './redux/systemDown/thunks';

const params = getSearchParameters();
if ('disableMaintenanceMode' in params && params.disableMaintenanceMode) {
  store.dispatch(byPassMaintenanceMode(true));
}

setInterval(getSystemStatus, 60 * 1000);

export const App: FunctionComponent = () => {
  const authStore = useTypedSelector((state) => state.auth);
  const systemDownStore = useTypedSelector((state) => state.systemDown);
  const dispatch = useAppDispatch();

  useEffect(() => {
    registerSessionTimeoutCallback(() => {
      logout(dispatch);
      toast('Your session expired. Please log in to continue.', {
        autoClose: false,
      });
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // load the current user info when there's an auth token
  useEffect(() => {
    if (authStore.token && !authStore.currentUser) {
      dispatch(fetchCurrentUser()).then((result) => {
        // if there was an error getting the current user's info, throw out the login token
        if (result.type === fetchCurrentUser.rejected.type) {
          logout(dispatch);
        }
      });
      dispatch(fetchGlobalConfigurations());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authStore.token]);

  if (
    !systemDownStore.isByPassMaintenanceMode &&
    systemDownStore.systemStatus.isSystemDown
  ) {
    return (
      <SystemDown restoreDate={systemDownStore.systemStatus.restoreDate} />
    );
  }
  // change the dashboard based on the user's type
  if (!authStore.token) {
    if (authStore.mfaLoginToken) {
      return <OTPForm mfaLoginToken={authStore.mfaLoginToken} />;
    }

    return <Login />;
  } else if (authStore.currentUser?.type === UserType.EMPLOYEE) {
    if (sessionStorage.getItem('adminAccessDealer')) {
      return <DealerLaunchDashboard showAdminView />;
    }
    return <SupportDashboard user={authStore.currentUser} />;
  } else if (authStore.currentUser?.type === UserType.CLIENT) {
    return <DealerLaunchDashboard />;
  }
  return <Spinner variant="fullscreen" />;
};
